import { captureTypedPosthogEvent, POSTHOG_EVENTS } from '~/common/posthogEvents';

/** Typed PostHog event wrappers for the org-admin Layer Library surface (CG-724). */

export function trackOrgLayerLibraryOpened(organizationId?: string): void {
  captureTypedPosthogEvent(POSTHOG_EVENTS.orgLayerLibraryOpened, { organization_id: organizationId });
}

export function trackOrgLayerLibraryLayerAdded(layerId: string, scope: string, organizationId?: string): void {
  captureTypedPosthogEvent(POSTHOG_EVENTS.orgLayerLibraryLayerAdded, {
    layer_id: layerId,
    scope,
    organization_id: organizationId,
  });
}

export function trackOrgLayerLibraryLayerRemoved(layerId: string, scope: string, organizationId?: string): void {
  captureTypedPosthogEvent(POSTHOG_EVENTS.orgLayerLibraryLayerRemoved, {
    layer_id: layerId,
    scope,
    organization_id: organizationId,
  });
}

export function trackOrgLayerLibraryReset(removedCount: number, organizationId?: string): void {
  captureTypedPosthogEvent(POSTHOG_EVENTS.orgLayerLibraryReset, {
    removed_count: removedCount,
    organization_id: organizationId,
  });
}

export function trackOrgLayerLibraryScopeChanged(from: string, to: string, organizationId?: string): void {
  captureTypedPosthogEvent(POSTHOG_EVENTS.orgLayerLibraryScopeChanged, {
    from,
    to,
    organization_id: organizationId,
  });
}

/** Fired on a committed, non-empty search. The raw query is intentionally omitted (PII). */
export function trackOrgLayerLibrarySearched(organizationId?: string): void {
  captureTypedPosthogEvent(POSTHOG_EVENTS.orgLayerLibrarySearched, { organization_id: organizationId });
}
